import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { isEqual } from 'lodash'
import { useLogoutMutation } from 'config/api/waV1_user'
import { COOKIE_TOKEN, URL_FILE_PREFIX } from 'config/const/global'
import { sidebarData } from 'config/dataToRender/sidebar'
import { LngSetter, tokenHandler } from 'config/slice/global'
import { toggleError, toggleNoti } from 'config/slice/message'
import { setSubtabById, setTabById, setSsubById } from 'config/slice/sidebar'
import { delCookie } from 'utils/cookies'
import {
    EN,
    KEY_TEXT_LABEL_ACCOUNT,
    KEY_TEXT_LABEL_COMPANY,
    KEY_TEXT_LOGOUT_SUCCESSFULLY,
    KEY_TEXT_MODAL_TITLE,
    KEY_TEXT_TIPS_I18N,
    MODULE_SIDEBAR,
    ZH,
    ZH_CN
} from 'config/const/locale'
import logo from 'assets/img/wa.svg'
import "./index.css"

const defaultData = sidebarData  // the data to render tabs

export default function Sidebar() {

    const [tabIsOpen, setTabIsOpen] = useState(true) // whether clicking the main tab
    const [subIsOpen, setSubIsOpen] = useState(true) // whether clicking the subtab tab
    const [isAdmin, setIsAdmin] = useState(false)
    const [isZH, setIsZH] = useState(4) // language indicator, 4 for tc, 2 for sc, 1 for en
    const { toggleSidebar, tabOpenId, subtabOpenId, ssubOpenId } = useSelector(state => state.sidebar) // redux state
    const { user } = useSelector(state => state.global) // redux state
    const { t } = useTranslation(MODULE_SIDEBAR) // i18n function
    const [logoutFn] = useLogoutMutation() // logout API
    const dispatch = useDispatch() // redux method
    const navigate = useNavigate()
    const { pathname } = useLocation()


    /**
     * tabs click handler
     * @param {Number} tabId the main tabs' id
     * @param {Boolean} open the state of the main tab, true clicked otherwise false
     */
    const tabSelectedHandler = (tabId, open) => () => {
        setTabIsOpen(open)
        dispatch(setTabById(tabId))
    }

    /**
     * subtabs click handler
     * @param {Number} subtabId subitems' id
     * @param {Boolean} open the state of subitems, true clicked otherwise false
     */
    const subtabSelectedHandler = (subtabId, open) => (e) => {
        e.stopPropagation()
        setTabIsOpen(open)
        dispatch(setSubtabById(subtabId))
        setSubIsOpen(open)
        dispatch(setSsubById(1))
    }

    /**
     * ssub click handler
     * @param {Number} subtabId subitems' id
     * @param {Boolean} open the state of subitems, true clicked otherwise false
     */
    const ssubSelectedHandler = (subtabId, open) => (e) => {
        e.stopPropagation()
        setSubIsOpen(open)
        dispatch(setSsubById(subtabId))
    }

    // clear cookie and redux's state when clicking logout btn
    const logoutBtnHandler = () => {

        logoutFn().then( // delete cookie and change redux's state if log out successfully
            resp => {
                if (resp?.error) {
                    dispatch(toggleError({
                        indicator: true,
                        msg: resp?.error?.data?.message
                    }))
                }
                else {
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_TEXT_LOGOUT_SUCCESSFULLY)
                    }))
                }
                delCookie(COOKIE_TOKEN)
                dispatch(tokenHandler({ switch: false }))
                navigate('/login')
            }
        )
    }

    /**
     * change language
     */
    const changeLng = () => {
        if (isZH == 4) {
            dispatch(LngSetter({ lng: ZH }))
            setIsZH(4 >> 1)
        }
        if (isZH == 2) {
            dispatch(LngSetter({ lng: ZH_CN }))
            setIsZH(2 >> 1)

        }
        if (isZH == 1) {
            dispatch(LngSetter({ lng: EN }))
            setIsZH(4)
        }
    }

    /**
     * add some classes to body
     */
    useEffect(() => {
        document.body.classList.add("sidebar-expanded")
        // document.body.classList.add("sidebar-collapse", "sidebar-closed")
        // if (isEqual(toggleSidebar, false)) document.body.classList.remove("sidebar-collapse", "sidebar-closed")
    }, [toggleSidebar])

    useEffect(() => {
        if (user?.user_roles?.indexOf('admin') !== -1) {
            setIsAdmin(true)
        }
        else {
            setIsAdmin(false)
        }
    }, [user])

    useEffect(() => {
        switch (pathname) {
            case '/users':
                dispatch(setTabById(1))
                break
            // case '/admin/hk/l':
            //     dispatch(setTabById(2))
            //     dispatch(setSubtabById(1))
            //     break
            // case '/admin/hk/ul':
            //     dispatch(setTabById(2))
            //     dispatch(setSubtabById(2))
            //     break
            // case '/admin/os/BVI':
            //     dispatch(setTabById(2))
            //     dispatch(setSubtabById(2))
            //     break
            case '/individualAcc':
                dispatch(setTabById(3))
                break
            case '/sug':
                dispatch(setTabById(7))
                break
            case '/apply/cs':
                dispatch(setTabById(4))
                dispatch(setSubtabById(8))
                dispatch(setSsubById(1))
                break
            case '/apply/cs1':
                dispatch(setTabById(4))
                dispatch(setSubtabById(8))
                dispatch(setSsubById(2))
                break

            default:
                dispatch(setTabById(3))
                break
        }
    }, [])

    return (
        <>
            {/* <!-- Main Sidebar Container --> */}
            <aside className="wa-sidebar main-sidebar sidebar-dark-primary elevation-4 wa-dark-blue wa-hide-scrollbar" style={{ overflowY: "scroll" }} >
                {/* <!-- Brand Logo --> */}
                <a href="/portal" className="wa-light-blue brand-link d-flex justify-content-between p-4 border-0">
                    <img src={logo} alt="logo" className="brand-image-xl"
                        style={{ opacity: 0.8, maxHeight: 50 }}
                    />
                    <span className="brand-text font-weight-light align-self-center fs-4" style={{ maxWidth: 130, whiteSpace: "wrap" }}>{t(KEY_TEXT_MODAL_TITLE)}</span>
                </a>

                {/* custom area including user info display area */}
                <div className="sidebar-custom border-0">
                    <div className='card wa-light-blue shadow-none'>
                        <div className="card-body p-0 wa-light-blue">
                            <div className="card wa-light-blue shadow-none">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div>
                                        <div className='wa-info-field-color'>{t(KEY_TEXT_LABEL_ACCOUNT)}</div>
                                        <div className="blockquote-reverse text-white">{user.name}</div>
                                    </div>
                                    <div className='order-1'>
                                        <div className="btn-group align-items-center justify-content-center">
                                            {/* <div className="btn wa-info-btn-bg rounded rounded-circle"><i className="bi bi-currency-dollar fs-4 text-dark"></i></div> */}
                                            <div className="btn wa-info-btn-bg rounded rounded-circle w-100 h-100 p-2">
                                                <a href={`${URL_FILE_PREFIX}/web/index.php`}>
                                                    <i className="fas fa-home fs-4 text-dark text-wa-light-blue"></i>
                                                </a>
                                            </div>
                                            <div className="btn wa-info-btn-bg rounded rounded-circle w-100 h-100 ms-3">
                                                <Link to={'/wallet'}>
                                                    <i className="fas fa-dollar-sign fs-4 text-dark text-wa-light-blue"></i>
                                                </Link>
                                            </div>
                                            <div className="btn p-2 wa-info-btn-bg rounded rounded-circle ms-3 w-100 h-100" onClick={logoutBtnHandler}><i className="fas fa-arrow-right-from-bracket fs-4 text-dark text-wa-light-blue"></i></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card wa-light-blue shadow-none">
                                <div className="card-body d-flex align-items-center justify-content-between">
                                    <div>
                                        <div className='wa-info-field-color'>{t(KEY_TEXT_LABEL_COMPANY)}</div>
                                        <div className="blockquote-reverse text-white">匯盟管理有限公司</div>
                                        <div className="small text-white">Well Alliance Management Limited</div>
                                    </div>
                                    <div className='order-1'>
                                        <div className="btn-group">
                                            {/* <div className="btn wa-info-btn-bg rounded-circle"><i className="bi bi-person fs-4 text-dark"></i></div> */}
                                            <div className="btn p-2 wa-info-btn-bg rounded rounded-circle w-100 h-100">
                                                <Link to={'profile'}>
                                                    <i className="fas fa-user-gear fs-4 text-dark text-wa-light-blue"></i>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* <!-- Sidebar --> */}
                <div className="sidebar p-0 wa-dark-blue h-auto">

                    {/* <!-- Sidebar Menu --> */}
                    <nav className="mt-2">
                        <ul className="nav nav-pills nav-sidebar flex-column nav-child-indent nav-legacy" data-lte-toggle="treeview" data-widget="treeview"  >
                            {/* <!-- Add icons to the links using the .nav-icon class with font-awesome or any other icon font library --> */}
                            {
                                defaultData.map(
                                    item => item.isAdminTab ? (
                                        item.isAdminTab == isAdmin ? (
                                            <li key={item.id} className={(tabIsOpen && isEqual(tabOpenId, item.id)) ? "nav-item menu-is-opening menu-open px-2 py-3 fs-5 border-bottom border-secondary" : "nav-item px-2 py-3 fs-5 border-bottom border-secondary"} onClick={tabSelectedHandler(item.id, isEqual(tabOpenId, item.id) ? !tabIsOpen : true)}>

                                                <Link to={item.to} className={isEqual(tabOpenId, item.id) ? (item.linkClass + " " + item.activeClass) : item.linkClass}>
                                                    {/* <i className={item.iconBeforeText}></i> */}
                                                    <p>
                                                        {t(item.key)}
                                                        <span className={item.badgeIcon}>{item.badgeText}</span>
                                                        <i className={item.iconAfterText}></i>
                                                    </p>
                                                </Link>
                                                <ul className="nav nav-treeview wa-dark-blue" >
                                                    {
                                                        item.subItems.map(
                                                            subitem => (
                                                                <li key={subitem.id} className="nav-item p-2" onClick={subtabSelectedHandler(subitem.id, true)}>
                                                                    <Link to={subitem.to} className={isEqual(subtabOpenId, subitem.id) ? subitem.linkClass + " " + subitem.activeClass : subitem.linkClass}>
                                                                        {/* <i className={subitem.iconBeforeText} ></i> */}
                                                                        <p>
                                                                            {t(subitem.key)}
                                                                            <span className={subitem.badgeIcon}>{subitem.badgeText}</span>
                                                                        </p>
                                                                    </Link>

                                                                    <ul className="my-nav wa-dark-blue" >
                                                                        {
                                                                            subitem?.subItems && subitem.subItems.map(
                                                                                ssub => (
                                                                                    <li key={ssub.id} className="nav-item p-2" onClick={ssubSelectedHandler(ssub.id, true)}>
                                                                                        <Link
                                                                                            to={ssub.to}
                                                                                            className={isEqual(ssubOpenId, ssub.id) ? ssub.linkClass + " " + ssub.activeClass : ssub.linkClass}
                                                                                        >
                                                                                            {/* <i className={ssub.iconBeforeText} ></i> */}
                                                                                            <p>
                                                                                                {t(ssub.key)}
                                                                                                <span className={ssub.badgeIcon}>{ssub.badgeText}</span>
                                                                                            </p>
                                                                                        </Link>
                                                                                    </li>
                                                                                )
                                                                            )
                                                                        }
                                                                    </ul>
                                                                </li>
                                                            )
                                                        )
                                                    }
                                                </ul>

                                            </li>
                                        ) : false
                                    ) : (
                                        <li key={item.id} className={(tabIsOpen && isEqual(tabOpenId, item.id)) ? "nav-item menu-is-opening menu-open px-2 py-3 fs-5 border-bottom border-secondary" : "nav-item px-2 py-3 fs-5 border-bottom border-secondary"} onClick={tabSelectedHandler(item.id, isEqual(tabOpenId, item.id) ? !tabIsOpen : true)}>

                                            <Link to={item.to} className={isEqual(tabOpenId, item.id) ? (item.linkClass + " " + item.activeClass) : item.linkClass}>
                                                {/* <i className={item.iconBeforeText}></i> */}
                                                <p>
                                                    {t(item.key)}
                                                    <span className={item.badgeIcon}>{item.badgeText}</span>
                                                    <i className={item.iconAfterText}></i>
                                                </p>
                                            </Link>
                                            <ul className="nav nav-treeview wa-dark-blue" >
                                                {
                                                    item.subItems.map(
                                                        subitem => (
                                                            <li key={subitem.id} className="nav-item p-2" onClick={subtabSelectedHandler(subitem.id, true)}>
                                                                <Link to={subitem.to} className={isEqual(subtabOpenId, subitem.id) ? subitem.linkClass + " " + subitem.activeClass : subitem.linkClass}>
                                                                    {/* <i className={subitem.iconBeforeText} ></i> */}
                                                                    <p>
                                                                        {t(subitem.key)}
                                                                        <span className={subitem.badgeIcon}>{subitem.badgeText}</span>
                                                                    </p>
                                                                </Link>

                                                                <ul className="my-nav wa-dark-blue" >
                                                                    {
                                                                        subitem?.subItems && subitem.subItems.map(
                                                                            ssub => (
                                                                                <li key={ssub.id} className="nav-item p-2" onClick={ssubSelectedHandler(ssub.id, true)}>
                                                                                    <Link
                                                                                        to={ssub.to}
                                                                                        className={isEqual(ssubOpenId, ssub.id) ? ssub.linkClass + " " + ssub.activeClass : ssub.linkClass}
                                                                                    >
                                                                                        {/* <i className={ssub.iconBeforeText} ></i> */}
                                                                                        <p>
                                                                                            {t(ssub.key)}
                                                                                            <span className={ssub.badgeIcon}>{ssub.badgeText}</span>
                                                                                        </p>
                                                                                    </Link>
                                                                                </li>
                                                                            )
                                                                        )
                                                                    }
                                                                </ul>
                                                            </li>
                                                        )
                                                    )
                                                }
                                            </ul>

                                        </li>
                                    )
                                )
                            }

                        </ul>
                    </nav>
                    {/* <!-- /.sidebar-menu --> */}

                    {/* toolkits */}
                    <div className="sidebar-custom mt-4 border-0">
                        <span title={t(KEY_TEXT_TIPS_I18N)} className="btn text-white fs-1" onClick={changeLng}><i className="fa-solid fa-language"></i></span>
                        <p className="text-white hide-on-collapse pos-right">* {t(KEY_TEXT_TIPS_I18N)}</p>
                        {/* <a href="#" class="btn btn-secondary hide-on-collapse pos-right">Help</a> */}
                    </div>

                </div>
                {/* <!-- /.sidebar --> */}


            </aside>
        </>
    )
}
